module.exports = __webpack_public_path__ + "img/DE01152.f753c8c0.png";